import React, { useState, useEffect } from "react";
import { Box, Text } from "grommet"; // Import Text for disclaimer
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { QuizFields } from "../../components/ManagerPortal/UserQuizFields";
import { QuizSummary } from "../../components/ManagerPortal/UserQuizSummary";
import { LinkPrevious } from "grommet-icons";
import { useNavigate, useLocation } from "react-router-dom";
import API_URL from "../../config/config";
import adminAxios from "../../config/adminAxios";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useQuizContext } from "../../contexts/QuizContext";
import { useParams } from "react-router-dom";
export const UserQuizSettingsPage = () => {
  const { assessment_id } = useParams();
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation to get the current location object
  const [quizSettings, setQuizSettings] = useState({
    difficulty: "Easy",
    numberOfQuestions: 10,
    skillDistribution: {},
  });
  const { user } = useContext(AuthContext);
  const { canAttemptQuiz, quizStarted, allowQuizAttempt, resetQuizAttempt } =
    useQuizContext();
  const user_id = user?.user_table_id ?? user?.user_id;
  // Extract the expertFlag from location.state
  const expertFlag = location.state?.expertFlag || false; // Default to false if not provided
  const productCount = location.state?.productCount || 0; // Default to 0 if not provided
  const subProductSkillIds = location.state?.subProducts || []; // Default to empty array if not provided

  // Function to format the date as YYYY-MM-DD
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  // Function to format the time as HH:MM:SS
  const formatTime = (date) => {
    const hours = `0${date.getHours()}`.slice(-2);
    const minutes = `0${date.getMinutes()}`.slice(-2);
    const seconds = `0${date.getSeconds()}`.slice(-2);
    return `${hours}:${minutes}:${seconds}`;
  };

  const handleStartAssessment = async () => {
    try {
      const now = new Date();
      const currentDate = formatDate(now); // Get the formatted date
      const currentTime = formatTime(now); // Get the formatted time
      
      const user_id = user?.user_table_id ?? user?.user_id;

      const data = {
        user_id,
        assessment_id: assessment_id,
        date: currentDate, // Use formatted date
        time: currentTime, // Use formatted time
      };
      
      await adminAxios.post(`${API_URL}/manager/insertQuizStart/`, data).then(
        (response) => {
          
        },
        (error) => {
          
        },
      );
      // if (response) {
      //   const assessmentId = response.data.assessment_id;
      //   const query_count = data.query_count;

      if (!quizStarted) {
        allowQuizAttempt();
      }
      navigate(`/${user_id}/assessment/${assessment_id}`, {
        state: {
          query_count: quizSettings.numberOfQuestions,
          subProductSkillIds: quizSettings.skillDistribution,
        },
      });
    } catch (error) {
      console.error("Error starting assessment:", error);
      alert("An error occurred while starting the assessment.");
    }
  };

  const handleSubmit = ({ totalQuestions, skillDistribution }) => {
    
    setQuizSettings({
      ...quizSettings,
      numberOfQuestions: totalQuestions, // Update total questions
      skillDistribution: skillDistribution, // Include skill-based question distribution
    });
    setShowSummary(true); // Move to the summary page
  };

  const handleModify = () => {
    setShowSummary(false);
  };

  return (
    <Box fill="vertical" justify="between">
      <Box flex="grow">
        <HeaderNavigation />
        <Box flex="grow">
          {/* )} */}

          {!showSummary ? (
            <QuizFields
              onSubmit={handleSubmit}
              productCount={productCount}
              data={user_id}
              assessment_id={assessment_id}
            />
          ) : (
            <QuizSummary
              difficulty={quizSettings.difficulty}
              numberOfQuestions={quizSettings.numberOfQuestions}
              onModify={handleModify}
              onStart={handleStartAssessment} // Call handleStartAssessment on start
            />
          )}
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};
